import { InjectionToken } from '@angular/core';
import { SharedConfig } from './models/shared-config.model';

export const sharedConfig = new InjectionToken<SharedConfig>('sharedConfig');
